import React, { useEffect, useState } from "react";

/**
 * Layout mode names (heuristic breakpoints matching our media queries):
 *
 * Width:
 *   XL   — >992px  (full desktop, everything at default)
 *   LG   — 769–992px (banner shifts up, Marc shrinks slightly)
 *   MD   — 601–768px (banner smaller, wing hidden, Marc smaller)
 *   SM   — ≤600px  (banner thin strip, Marc compact)
 *
 * Height:
 *   TALL  — >700px  (default, everything at normal position)
 *   MID   — 501–700px (banner/Marc shift up, wing hidden)
 *   SHORT — ≤500px  (banner minimal, Marc compact)
 */

function getWidthMode(w: number): string {
  if (w > 992) return "XL";
  if (w > 768) return "LG";
  if (w > 600) return "MD";
  return "SM";
}

function getHeightMode(h: number): string {
  if (h > 700) return "TALL";
  if (h > 500) return "MID";
  return "SHORT";
}

export default function DebugOverlay() {
  const [dims, setDims] = useState({ w: window.innerWidth, h: window.innerHeight });

  useEffect(() => {
    const onResize = () => setDims({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Only show in development
  if (process.env.NODE_ENV !== "development") return null;

  const wMode = getWidthMode(dims.w);
  const hMode = getHeightMode(dims.h);

  return (
    <div
      style={{
        position: "fixed",
        top: 8,
        right: 8,
        zIndex: 99999,
        background: "rgba(204, 180, 0, 0.92)",
        color: "#000",
        fontFamily: "monospace",
        fontSize: 12,
        fontWeight: 700,
        padding: "6px 10px",
        borderRadius: 4,
        pointerEvents: "none",
        lineHeight: 1.5,
        textAlign: "right",
      }}
    >
      <div>{wMode} / {hMode}</div>
      <div style={{ fontSize: 10, fontWeight: 400 }}>
        {dims.w} × {dims.h}
      </div>
    </div>
  );
}
